import React from "react";
import { LoadingIndicator, ModalV2, Text } from "@jsq/ds/core";
import { useBillingExportPolling } from "~/pages/Billing/hooks/useBillingExportPolling";

interface BillingGeneratingModalProps {
  showGeneratingModal: boolean;
  closeGeneratingModal: () => void;
  exportId: string | null;
  onJobStatusChange?: (inProgress: boolean) => void;
}

export const BillingGeneratingModal: React.FC<BillingGeneratingModalProps> = ({
  showGeneratingModal,
  closeGeneratingModal,
  exportId,
  onJobStatusChange,
}) => {
  const { isPollingInProgress } = useBillingExportPolling({
    exportId,
    onJobStatusChange,
    closeModal: closeGeneratingModal,
    enabled: showGeneratingModal,
  });

  return (
    <ModalV2
      show={showGeneratingModal}
      onHide={closeGeneratingModal}
      data-testid="generating-export-data-modal"
      backdrop={true}
      closeOnClickOutside={true}
      closeButton={!isPollingInProgress}
      title="Generating Export"
    >
      <ModalV2.Body>
        <Text align="left" marginBottom="md">
          Your export is being generated. It will download automatically when complete.
        </Text>
        {isPollingInProgress && <LoadingIndicator variant="primary" />}
      </ModalV2.Body>
    </ModalV2>
  );
};
